// Images need to be imported correctly for webpack to process them
import logo from './logo4-removebg-preview.png';
import logoBg from './lo_be.png';
import yogaImg from './yo_img.png';
import loader from './champyoga.gif';
import typ from './TYP.png';
import dpw from './DPW.png';
import nswy from './NSWY.png';
import openart from './openart.jpg';
import goodJob from './good-job.gif';
import im from './IM.jpg';
import beg from './Beg.jpg';
import adv from './adv.jpg';
import intC from './IntC.jpg';
import e1 from './E1.jpg';
import e3 from './E3.jpg';
import e4 from './E4.jpg';
import tQuote from './t.png';
import tess from './tess.png';
// Ensure the yoga GIF is properly imported
import yogaGif from './good-job.gif'; // You might need to adjust the filename if different

const IMAGES = {
  logo,
  logoBg,
  yogaImg,
  loader,
  typ,
  dpw,
  nswy,
  openart,
  goodJob,
  yogaGif, // Add this explicitly for clarity
  im,
  beg,
  adv,
  intC,
  e1,
  e3,
  e4,
  tQuote,
  tess
};

export default IMAGES;
